import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { GetReward } from './rewards.interface';
import { environment } from 'src/environments/environment';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ConvertService } from 'src/app/services/convert.service';
import { AlertService } from 'src/app/services/alert.service';
import moment from 'moment';

@Component({
  selector: 'app-rewards',
  templateUrl: './rewards.component.html',
  styleUrls: ['./rewards.component.scss']
})
export class RewardsComponent {
  contentReward = environment.contentReward
  constructor(private http: HttpClient,
    private fb: FormBuilder,
    private con: ConvertService,
    private alert: AlertService
  ) {
    this.getReward();
  }
  formReward: FormGroup | any = this.fb.group(<GetReward>{
    ID: "",
    Name: "",
    Type: "",
    Image: "",
    Image_delete: "",
    Image_update: "",
    Point: 0,
    Deduct: 0,
    Remaining: 0,
    DisType: "",
    DisAmount: 0,
    Description: "",
    Condition: "",
    Expire: 1,
    Expire_start_edit: "",
    Expire_end_edit: "",
    Expire_start: "",
    Expire_end: ""
  })

  setitem: any = [];
  imageAction: boolean = false;
  rewardItems!: GetReward[]
  pageTotal: number = 0
  getReward(v?: any) {
    let uri: string = `reward?page=${v?.page || 1}&limit=15`
    if (v?.value) {
      uri = `reward?search=${v.value}&page=${v?.page || 1}&limit=15`
    }
    this.http.get(uri).subscribe({
      next: (res: any) => {
        this.rewardItems = res.data
        this.pageTotal = res.pageTotal
      }
    })
  }

  viewMenu(items: any, elm: any, v: any) {
    let model: any[] = [];
    model.push({ label: 'แก้ไข', command: () => this.viewReward(items) });
    model.push({ label: 'ลบ', command: () => this.deleteReward(items) });


    this.setitem = model;
    elm.toggle(v);
  }

  message: string = ""
  manageReward: boolean = false
  addStatus: boolean = false;
  addReward() {
    this.message = "เพิ่มรางวัล"
    this.manageReward = true
    this.addStatus = true;
    this.setDateDefault()
  }

  updateStatus: boolean = false;
  updateItems!: GetReward
  viewReward(item: GetReward) {
    if (item.Image) this.imageAction = true
    this.formReward.patchValue(item)
    this.setDate(item)
    this.updateItems = item;
    this.message = "แก้ไขรางวัล"
    this.manageReward = true
    this.updateStatus = true;
  }

  setDateDefault() {
    this.formReward.get('Expire').setValue(1)
    let dateStart: string = ""
    let editStart: string = ""
    let dateEnd: string = ""
    let editEnd: string = ""
    // START
    editStart = moment(new Date()).format('DD/MM/YYYY')
    this.formReward.get('Expire_start_edit').setValue(editStart)
    dateStart = moment(new Date()).format('YYYY-MM-DD')
    this.formReward.get('Expire_start').setValue(dateStart)

    // END
    editEnd = moment(new Date()).format('DD/MM/YYYY')
    this.formReward.get('Expire_end_edit').setValue(editEnd)
    dateEnd = moment(new Date()).format('YYYY-MM-DD')
    this.formReward.get('Expire_end').setValue(dateEnd)
  }

  setDate(item: GetReward) {
    let dateStart: string = ""
    let editStart: string = ""
    let dateEnd: string = ""
    let editEnd: string = ""
    // START
    editStart = moment(new Date()).format('DD/MM/YYYY')
    this.formReward.get('Expire_start_edit').setValue(editStart)
    dateStart = moment(new Date()).format('YYYY-MM-DD')
    this.formReward.get('Expire_start').setValue(dateStart)

    // END
    editEnd = moment(new Date()).format('DD/MM/YYYY')
    this.formReward.get('Expire_end_edit').setValue(editEnd)
    dateEnd = moment(new Date()).format('YYYY-MM-DD')
    this.formReward.get('Expire_end').setValue(dateEnd)

    if (item.Expire_start) {
      editStart = moment(item.Expire_start).format('DD/MM/YYYY')
      this.formReward.get('Expire_start_edit').setValue(editStart)
      dateStart = moment(item.Expire_start).format('YYYY-MM-DD')
      this.formReward.get('Expire_start').setValue(dateStart)
    }
    if (item.Expire_end) {
      editEnd = moment(item.Expire_end).format('DD/MM/YYYY')
      this.formReward.get('Expire_end_edit').setValue(editEnd)
      dateEnd = moment(item.Expire_end).format('YYYY-MM-DD')
      this.formReward.get('Expire_end').setValue(dateEnd)
    }
  }



  viewImage: string = ""
  uploadFile(e: any) {
    let item: GetReward = this.formReward.value;
    this.formReward.get('Image_delete').setValue(item.Image)
    this.formReward.get('Image_update').setValue(e.file)
    this.viewImage = e.base64
    if (this.viewImage) this.imageAction = true
  }

  updateExpire(v: any, key: string) {
    if (key == 'start') {
      let date = moment(v).format('YYYY-MM-DD')
      this.formReward.get('Expire_start').setValue(date)
      return
    }
    if (key == 'end') {
      let date = moment(v).format('YYYY-MM-DD')
      this.formReward.get('Expire_end').setValue(date)
    }

  }


  createReward() {
    this.http.post(`reward`, this.con.paseFormData(this.formReward.value)).subscribe({
      next: (res: any) => {
        this.getReward()
        this.clearEvent()
        this.alert.notify(res.message, 'success')
      }, error: (err) => {
        this.alert.dialog(err.error.message)
      },
      complete: () => {

        this.clearEvent()
      }
    })
  }

  updateReward() {
    this.http.put(`reward/${this.formReward.value['ID']}`, this.con.paseFormData(this.formReward.value)).subscribe({
      next: (res: any) => {
        this.getReward()
        this.clearEvent()
        this.alert.notify(res.message, 'success')
      }, error: (err) => {
        this.alert.dialog(err.error.message)
      },
      complete: () => {

      }
    })
  }


  deleteReward(item: GetReward) {
    this.alert.confirm('ต้องการลบรางวัลนี้หรือไม่').then(fm => {
      if (fm.isConfirmed) this.http.delete(`reward/${item.ID}`).subscribe({
        next: (res: any) => {
          this.getReward()
          this.alert.notify(res.message, 'success')
        }, error: (err) => {
          this.alert.dialog(err.error.message)
        },
        complete: () => {
          this.clearEvent()
        }
      })
    })

  }

  deduct(v: any) {
    if (v.value == 0) {
      this.formReward.get('Deduct').setValue(1)
      return
    }

    else this.formReward.get('Deduct').setValue(0)
  }


  expire(v: any) {
    if (v.value == 0) {
      this.formReward.get('Expire').setValue(1)
      this.setDate(this.formReward.value)
      return
    }

    else {
      this.formReward.get('Expire').setValue(0)
      this.formReward.get('Expire_start').setValue("")
      this.formReward.get('Expire_end').setValue("")
    }
  }


  clearEvent() {
    this.formReward.reset()
    this.message = ""
    this.updateStatus = false
    this.manageReward = false
    this.addStatus = false;
    this.updateStatus = false
    this.viewImage = ""
    this.imageAction = false;
  }
}
